import { request } from 'core/constants'
import { requestState } from 'utils/UtilityStore/actions'

export const fetch =
  (filter, order = null, orderDirection = null) =>
  (dispatch) => {
    dispatch(requestState(true, 'properties'))
    const orderBy = order && orderDirection ? order + ',' + orderDirection : ''

    request
      .get(
        `{company}/property?page=${filter?.page || 1}&search=${
          filter?.search || ''
        }&orderBy=${orderBy}`,
      )
      .then((response) => {
        dispatch(requestState(false, 'properties'))
        dispatch({
          type: 'FETCH_PROPERTIES',
          payload: response.data,
          listInfo: response.resultsInfo,
        })
      })
      .catch((error) => {})
  }
